import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import ClickOutside from 'vue-click-outside'

export default {
	template: "#checkout-payment",
	props: {
		step: {
			type: Object,
			required: true
		}
	},
	data() {
		return {

		}
	},
	components: {
	},
	computed: {
        ...mapGetters({
			paySystems: "payment/paySystems",
			activePaySystem: "payment/activePaySystem",
			activeStep: "checkout/activeStep"
		}),
		...mapState({
			errorMessages: state => state.checkout.errorMessages,
			extra: state => state.checkout.extra,
			isAdmin: state => state.checkout.isAdmin
		}),
		stepDisabled() {
			return this.step.disabled;
		},
		isActive() {
			return this.step.id === this.activeStep.id;
		},
		showPaySystemIcons() {
			return this.extra.paySystemIcons;
		},
		paymentMessage() {
			return this.extra.paymentMessage;
		}
	},
	methods: {
		...mapMutations({
			setActivePaySystem: "payment/setActivePaySystem",
			setStepValidState: "checkout/setStepValidState"
		}),
		...mapActions({
			refreshOrder: "checkout/refreshOrder",
			nextStep: "checkout/nextStep",
			blockSteps: "checkout/blockSteps"
		}),
		clickOutside(e) {
		},
		scrollToComments(e) {
			if (window.innerWidth < 768) {
			const commentElement = document.getElementById("comment");
			commentElement.scrollIntoView({block: "center", behavior: "smooth"});
			}
		},
		changeType(id) {
			this.setActivePaySystem(id);
			this.refreshOrder().then(() => {
				this.checkComponentValidity();
			});
			this.scrollToComments();
		},
		checkComponentValidity() {
			let valid = (this.activePaySystem) ? true : false;
			if (valid) {
				this.setStepValidState({stepId: this.step.id, value: true});
				this.nextStep(this.step);
			} else {
				this.setStepValidState({stepId: this.step.id, value: false});
				this.blockSteps();
			}
		}
	},
	watch: {
		stepDisabled(val) {
			if (!val) {
				this.$nextTick(() => this.checkComponentValidity());
			}
		}
	},
	directives: {
		ClickOutside
	},
	mounted() {
	},
	created() {
	}
}
